import KeywordListFloatingBtn from './KeywordListFloatingBtn.vue';

export default KeywordListFloatingBtn;
